export default __webpack_public_path__ + "static/media/delete.bbe0680a.svg";